import { render } from "./BuildMyApp.vue?vue&type=template&id=217d793d&scoped=true"
import script from "./BuildMyApp.vue?vue&type=script&lang=js"
export * from "./BuildMyApp.vue?vue&type=script&lang=js"

import "./BuildMyApp.vue?vue&type=style&index=0&id=217d793d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217d793d"]])

export default __exports__